export const FileName = (fullUrl) => {
    const fragment = fullUrl.split('/');
    return fragment[fragment.length-1];
}

export const FileRoute = (fullUrl) => {
    const fragment = fullUrl.split('/pdf/');
    return fragment[1];
}